// utils.js

let debounceTimer = null;

/**
 * Custom debounce implementation without using lodash.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} delay - Debounce delay in milliseconds.
 * @returns {Function} - Debounced function.
 */
export const customDebounce = (func, delay = 500) => {
  return (...args) => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
